"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var classnames_1 = __importDefault(require("classnames"));
var PaymentMethodBox = function (_a) {
    var _b;
    var children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, additionalInfo = _a.additionalInfo, rest = __rest(_a, ["children", "disabled", "className", "additionalInfo"]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(className, styles_scss_1["default"].paymentMethodBox, (_b = {},
            _b[styles_scss_1["default"].paymentMethodBoxDisabled] = disabled,
            _b)) }, { children: [children, (0, jsx_runtime_1.jsx)("p", { children: "Po odoslan\u00ED objedn\u00E1vky \u0165a presmerujeme na Ahoj, kde prejde\u0161 r\u00FDchlym overen\u00EDm a podp\u00ED\u0161e\u0161 zmluvu online." }), additionalInfo] })));
};
exports["default"] = PaymentMethodBox;
